import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from 'styled-components';
import ButtonBase, { buttonTextColor, buttonHoverStyle, buttonActiveStyle, buttonDisabledStyle, buttonFontSize, FONT_WEIGHT } from '../ButtonBase';
import { transitionSpeed } from '../../../styles/animation';
export var ButtonStyled = styled.button(function (props) {
  return _objectSpread(_objectSpread({}, ButtonBase(props)), {}, {
    color: buttonTextColor(props.typeStyle, props.color),
    cursor: 'pointer',
    display: 'inline-flex',
    verticalAlign: 'top',
    justifyContent: 'center',
    alignItems: 'center',
    outline: 'none',
    fontFamily: 'inherit',
    fontSize: "".concat(buttonFontSize(props.size), "px"),
    fontWeight: FONT_WEIGHT,
    transition: "all ".concat(transitionSpeed, " ease-in-out"),
    '&[disabled]': _objectSpread(_objectSpread({}, buttonDisabledStyle(props.typeStyle)), {}, {
      cursor: 'default'
    }),
    '&:not([disabled])': {
      '&:hover, &:focus, &.docz-hover-focus': _objectSpread({}, buttonHoverStyle(props.typeStyle)),
      '&:active, &.docz-active': _objectSpread({}, buttonActiveStyle(props.typeStyle))
    }
  });
});
export var ButtonContent = styled.span({
  '&:not(:only-child)': {
    display: 'inline-block',
    marginLeft: '6px'
  }
});
export var NoWrap = styled.span({
  alignItems: 'center',
  display: 'inline-flex',
  whiteSpace: 'nowrap'
});